import React, { useContext, useState, useEffect, useCallback } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { NavLink } from './home/migration';
import { mainBody, about } from '../editable-stuff/config.js';
import { ThemeContext } from '../App';
import { motion } from 'framer-motion';

const Navigation = React.forwardRef((props, ref) => {
  const { theme } = useContext(ThemeContext);
  const [isTop, setIsTop] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const navbarMenuRef = React.useRef(null);

  // Simplified scroll detection - navbar becomes solid after scrolling past 100px
  const handleScroll = useCallback(() => {
    const scrollY = window.scrollY || window.pageYOffset;
    setIsTop(scrollY < 100);
  }, []);

  useEffect(() => {
    // Set initial state
    handleScroll();

    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  // Close mobile menu when clicking outside or on a link
  const handleNavClick = useCallback(() => {
    if (window.innerWidth < 992) {
      setExpanded(false);
    }
  }, []);

  // Close menu on window resize if it becomes desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setExpanded(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navItems = [
    { label: 'About', href: process.env.PUBLIC_URL + '/#aboutme' },
    { label: 'Skills', href: process.env.PUBLIC_URL + '/#skills' },
    { label: 'Certifications', href: process.env.PUBLIC_URL + '/#certifications' },
    { label: 'Blogs', href: process.env.PUBLIC_URL + '/#blogs' },
    { label: 'Proficiency', href: process.env.PUBLIC_URL + '/#proficiency' },
    { label: 'Get-In-Touch', href: process.env.PUBLIC_URL + '/#getintouch' },
    { label: 'Resume', href: about.resume, external: true }
  ];

  return (
    <motion.div
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
    >
      <Navbar
        expanded={expanded}
        ref={navbarMenuRef}
        className={`px-3 fixed-top ${!isTop ? 'navbar-white' : 'navbar-transparent'} ${isTop ? 'navbar-at-top' : ''}`}
        expand="lg"
        variant={theme}
      >
        <motion.div
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Navbar.Brand 
            className="navbar-brand" 
            href={process.env.PUBLIC_URL + '/#home'}
          >
            {`<${mainBody.firstName} />`}
          </Navbar.Brand>
        </motion.div>
        
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          aria-expanded={expanded}
          className="toggler"
          onClick={() => setExpanded(!expanded)}
        />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav
            className="navbar-nav ms-auto"
            onClick={handleNavClick}
          >
            {navItems.map((item, index) => (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, y: -16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.03 }}
              >
                <NavLink
                  className="nav-item lead"
                  href={item.href}
                  target={item.external ? '_blank' : undefined}
                  rel={item.external ? 'noreferrer noopener' : undefined}
                >
                  {item.label}
                </NavLink>
              </motion.div>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </motion.div>
  );
});

Navigation.displayName = 'Navigation';

export default Navigation;
